import React, { FC } from 'react';
import warningImg from './assets/Warning.png';
import arrowImg from './assets/synchronize-arrows-square.png';
import { DetailWrapper, LeftIcon, LeftParagraphWrapper, LineWrapper } from './style';
import { Paragraph } from 'hui';

interface ParseFailedProps {
  detail: string[];
  failReason: string;
}

const ParseFailed: FC<ParseFailedProps> = ({ detail, failReason }) => (
  <div>
    <LineWrapper>
      <LeftIcon alt="synchronize arrows square" src={arrowImg} />
      <Paragraph mb={0}>Parsing completed</Paragraph>
    </LineWrapper>
    <LineWrapper>
      <LeftIcon alt="warning" src={warningImg} />
      <Paragraph mb={0}>Parse failed</Paragraph>
    </LineWrapper>
    <LineWrapper>
      <LeftParagraphWrapper>
        <Paragraph mb={0} bold>
          Fail reason:
        </Paragraph>
      </LeftParagraphWrapper>
      <Paragraph mb={0}>{failReason}</Paragraph>
    </LineWrapper>
    <DetailWrapper>
      <LeftParagraphWrapper>
        <Paragraph mb={0} bold>
          Detail:
        </Paragraph>
      </LeftParagraphWrapper>
      <div>
        {detail.map(dtl => (
          <Paragraph mb={0} key={Math.random()}>
            {dtl}
          </Paragraph>
        ))}
      </div>
    </DetailWrapper>
  </div>
);

export default ParseFailed;
